import { useState, useCallback } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import roleApi, { Role } from '../../../../../api/role';
import { Form } from './Form';
import { Table } from '../shared/Table';

type Props = {
  action: string;
};

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'name', headerName: 'Nombre', width: 130 },
  { field: 'description', headerName: 'Descripción', width: 200 },
  {
    field: 'isActive',
    headerName: 'Activo',
    width: 90,
  },
];

export const Wrapper: React.FC<Props> = ({ action }) => {
  const [selectedRow, setSelectedRow] = useState<Role | undefined>();
  const [roles, setRoles] = useState<Role[] | []>([]);
  const [tableError, setTableError] = useState<string>('');
  const [isTableLoading, setIsTableLoading] = useState<boolean>(true);

  const fetchRoles = useCallback(async () => {
    setIsTableLoading(true);
    try {
      const responseRoles = await roleApi.getRoles();
      const rolesData = responseRoles?.data;
      setRoles(rolesData);
    } catch {
      setTableError('Ha ocurrido un error al obtener los roles.');
    }
    setIsTableLoading(false);
  }, []);

  return action === 'add' ? (
    <Form />
  ) : (
    <>
      <Table
        setSelectedRow={setSelectedRow}
        rows={roles}
        columns={columns}
        error={tableError}
        isLoading={isTableLoading}
        setIsTableLoading={setIsTableLoading}
        fetchTable={fetchRoles}
        sortedBy={[
          {
            field: 'name',
            sort: 'asc',
          },
        ]}
      />
      <Form
        isEditing={action === 'modify'}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        fetchRoles={fetchRoles}
      />
    </>
  );
};
